const Button = {
  // The styles all button have in common
  baseStyle: {
    color: "#fff",
    fontFamily: "Rubik, 'sans-serif'",
    // fontFamily: "PingFang SC Medium",
    fontSize: "14px",
    fontWeight: 400,
    borderRadius: "4px",
    _focus: { border: "none", outline: "none" },
  },

  sizes: {
    sm: { px: "12px", py: "8px", fontSize: "14px", lineHeight: "17px" },
    md: { px: "20px", py: "8px", fontSize: "14px", lineHeight: "16px" },
    lg: { px: "24px", py: "8px", fontSize: "14px", lineHeight: "16px" },
  },

  variants: {
    tertiary: {
      bg: "secondary.500",
      fontWeight: "medium",
      fontSize: "sm",
      border: "2px solid",
      borderColor: "secondary.500",
      _hover: { bg: "secondary.400" },
    },
  },

  // default values for `size` and `variant`
  defaultProps: {
    size: "md",
    variant: "primary",
  },
};

export default Button;
